var _defs, _rect, _circle, _circle2, _circle3, _g, _rect2, _g2, _g3, _g4, _g5, _circle4, _circle5, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 700,
    viewBox: "0 0 900 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 900,
    y2: 700
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primary",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2563EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 12,
    floodOpacity: 0.15
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 700,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 80,
    fill: "#DBEAFE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 90,
    r: 60,
    fill: "#BFDBFE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 580,
    r: 100,
    fill: "#DBEAFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 120,
    width: 560,
    height: 350,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 145,
    width: 510,
    height: 300,
    rx: 10,
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 145,
    width: 510,
    height: 48,
    rx: 10,
    fill: "url(#primary)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 169,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 169,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 169,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 210,
    width: 110,
    height: 210,
    rx: 10,
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 230,
    width: 70,
    height: 12,
    rx: 6,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 260,
    width: 55,
    height: 10,
    rx: 5,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 285,
    width: 55,
    height: 10,
    rx: 5,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 310,
    width: 55,
    height: 10,
    rx: 5,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 220,
    width: 150,
    height: 90,
    rx: 14,
    fill: "#DBEAFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 220,
    width: 150,
    height: 90,
    rx: 14,
    fill: "#E0F2FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 330,
    width: 320,
    height: 70,
    rx: 14,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "370,380 410,355 450,365 500,320 560,335 620,285",
    fill: "none",
    stroke: "#2563EB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 285,
    r: 6,
    fill: "#2563EB"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 470,
    width: 660,
    height: 18,
    rx: 9,
    fill: "#CBD5E1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 260,
    width: 120,
    height: 220,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645,
    y: 290,
    width: 90,
    height: 155,
    rx: 12,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 330,
    width: 45,
    height: 40,
    rx: 6,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 330          C676 315 705 315 705 330",
    stroke: "white",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 400,
    r: 18,
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 400          L688 406          L700 392",
    stroke: "white",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 540,
    r: 40,
    fill: "url(#primary)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 525          H112          L120 555          H145          L152 535          H118",
    stroke: "white",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 563,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 563,
    r: 4,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 520,
    width: 90,
    height: 70,
    rx: 10,
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 755,
    y1: 520,
    x2: 755,
    y2: 590,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 710,
    y1: 555,
    x2: 800,
    y2: 555,
    stroke: "white",
    strokeWidth: 3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 520,
    cy: 70,
    rx: 45,
    ry: 25,
    fill: "#DBEAFE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 555,
    cy: 65,
    rx: 35,
    ry: 22,
    fill: "#DBEAFE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 490,
    cy: 65,
    rx: 30,
    ry: 20,
    fill: "#DBEAFE"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 100,
    r: 5,
    fill: "#2563EB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 145,
    r: 5,
    fill: "#2563EB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 105,
    x2: 520,
    y2: 145,
    stroke: "#2563EB",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.af3753f8ea1316a9498cb76ce8c65de7.svg";
export { ForwardRef as ReactComponent };